import React, { forwardRef, InputHTMLAttributes } from "react"
import { Text } from "../Text"
import { cn } from "@/utils/classnames"

interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  children?: React.ReactNode
  wrapperClassName?: string
  checkBoxSize?: "sm" | "md" | "lg"
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, wrapperClassName, children, checkBoxSize = "sm", ...props }, ref) => {
    const sizeClasses = {
      sm: "size-4",
      md: "size-5",
      lg: "size-6",
    }
    const size = sizeClasses[checkBoxSize]

    return (
      <label className={cn("flex cursor-pointer items-center gap-x-3", wrapperClassName)}>
        <input
          ref={ref}
          type="checkbox"
          {...props}
          className={cn(
            "cursor-pointer rounded-sm border-bg-4 checked:border-fg-1 checked:bg-fg-1 focus:ring-transparent",
            props.className,
            size
          )}
        />
        {label && (
          <div className="mb-2">
            <Text variant="label" className="select-none">
              {label}
            </Text>
          </div>
        )}
        {children}
      </label>
    )
  }
)

Checkbox.displayName = "Checkbox"
